// extracted by mini-css-extract-plugin
export default {"athlogn_txt":"athlete_athlogn_txt__GK1GT","athltlgn_txtgrp_width_50":"athlete_athltlgn_txtgrp_width_50__zsD6D"};